import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { CustomPage } from "src/app/models/custom-page-model";
import { DefaultService } from "src/app/services/default/default.service";
import { Webflow } from "src/app/utils/webflow";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-reservations",
  templateUrl: "./reservations.component.html",
  styleUrls: ["./reservations.component.scss"],
})
export class ReservationsComponent implements OnInit {
  show_add_button: boolean = false;
  show_delete_button: boolean = false;
  show_edit_button: boolean = false;
  custom_page: CustomPage;

  custom_buttons: Array<any> = [
    {
      text: '<i class="fa fa-sync"></i> Actualiser',
      class: "btn btn-xl btn-outline-studiomap",
      action: () => {
        this.redirectTo("/reservations", {});
      },
    },
  ];

  columns: Array<any> = [
    {
      keys: [
        {
          key: "artist",
          field_relation: "full_name",
          class: "",
        },
        {
          key: "artist",
          field_relation: "email",
          class: "font-weight-bold",
        },
        {
          key: "artist_phone",
          field_relation: "",
          class: "",
          concat_field_before: "",
          concat_field_after: "",
        },
      ],
      type: "card",
      value: "Utilisateur",
    },

    {
      key: "studio_name",
      type: "button",
      class: "btn btn-primary btn-sm",
      value: "Studio",
      concat_value: "",
      field_relation: "",
      onClick: (value: any) => {
        Webflow.myAction(this.router, "studios/edit/" + value.studio.id, {});
      },
    },
    {
      key: "start_date",
      type: "datetime",
      class: "font-weight-bold",
      value: "Date début",
      concat_value: "",
      field_relation: "",
      order_by: true,
      order_by_option: "desc",
    },
    {
      key: "status",
      type: "enum",
      class: {
        pending: "badge badge-warning",
        confirmed: "badge badge-success",
        canceled: "badge badge-danger",
        failed: "badge badge-danger",
        "waiting-confirmation": "badge badge-primary",
      },
      text: {
        pending: "Demandé",
        confirmed: "Confirmé",
        canceled: "Annulé",
        failed: "Échoué",
        "waiting-confirmation": "En attente de confirmation",
      },
      value: "Status",
      concat_value: "",
      field_relation: "",
      list: [
        { value: "pending", text: "Demandé" },
        { value: "confirmed", text: "Confirmé" },
        { value: "canceled", text: "Annulé" },
        { value: "failed", text: "Échoué" },
        { value: "waiting-confirmation", text: "En attente de confirmation" },
      ],
    },
    {
      key: "createdAt",
      type: "date",
      class: "badge badge-info font-weight-bold",
      value: "Date de création",
      concat_value: "",
      field_relation: "",
      order_by: true,
      order_by_option: "desc",
    },
  ];

  multi_actions: Array<any> = [];

  visible_actions: Array<any> = [
    {
      title: "Détails",
      icon: "fa	fa-list",
      class: "text-info",
      onClick: (value: any) => {
        Webflow.myAction(this.router, "reservations/info/" + value.id, {});
      },
    },
  ];

  invisible_actions: Array<any> = [];

  constructor(
    private defaultService: DefaultService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      let filters = "&populate=studio,artist";
      filters +=
        params.studio != undefined &&
        params.studio != "" &&
        params.studio != null
          ? "&filters[studio][id]=" + params.studio
          : "";
      filters +=
        params.artist != undefined &&
        params.artist != "" &&
        params.artist != null
          ? "&filters[artist][id]=" + params.artist
          : "";
      this.custom_page = new CustomPage(
        "reservations",
        "",
        "reservations",
        "/find-for-manager",
        filters
      );
    });
  }

  redirectTo(uri: string, params: any) {
    this.router
      .navigateByUrl("/", { skipLocationChange: false })
      .then(() => this.router.navigate([uri], { queryParams: params }));
  }
}
